// import React from "react";
// import Navbar from "../../Components/Navbar";
// import Header from "../../Components/Header";
// import { Container, Typography } from "@mui/material";
// import Footer from "../../Components/Footer";
// import CallToEnroll from "../../Components/CallToEnroll";
// import PageTitle from "../../Components/PageTitle";
// import MilitaryBanner from "../../assets/Military.png";

// const Military = () => {
//   return (
//     <>
//       <Navbar />
//       <PageTitle
//         title="Military School Coaching - Shree Mangalam School"
//         description="Get the best coaching for Military School entrance exams at Shree Mangalam School. Expert guidance, mock tests, and a disciplined learning environment."
//         url="/military"
//         keywords="military school coaching, RMS coaching, military entrance exam preparation, Rashtriya Military School classes, Shree Manglam military coaching"
//       />

//       <Header image={MilitaryBanner} alt={"Military School Coaching Banner"} />

//       <Container sx={{ mb: 5, mt: 5 }}>
//         <Typography
//           variant="h5"
//           sx={{
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             fontSize: "30px",
//             letterSpacing: 1,
//             color: "#065A79",
//             fontWeight: "bold",
//           }}
//           gutterBottom
//         >
//           Rashtriya Military School (RMS)
//         </Typography>
//         <Typography
//           variant="body1"
//           sx={{
//             mt: 3,
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             letterSpacing: 1,
//             lineHeight: "1.8rem",
//           }}
//         >
//           At Shree Mangalam School, we proudly offer expert
//           coaching for the Rashtriya Military School (RMS) Entrance Examination,
//           preparing students for a life of discipline, leadership, and national
//           pride. Our program is tailored to help students from jaipur-gudha state highway (Just on by pass) gudha gorji,
//           and neighboring towns secure admission into India’s
//           premier military schools — institutions that shape the future leaders
//           of our armed forces.
//         </Typography>

//         <Typography
//           variant="body1"
//           sx={{
//             mt: 2,
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             letterSpacing: 1,
//             lineHeight: "1.8rem",
//           }}
//         >
//           The Military School entrance coaching covers all key subjects:
//           Mathematics, English, General Knowledge, and Intelligence Reasoning,
//           aligned with the latest exam pattern. We ensure thorough practice
//           through mock exams, doubt-solving sessions, and interview preparation.
//           Special attention is given to character building, time management, and
//           physical fitness tips, so students are ready for every stage of the
//           selection process.
//         </Typography>

//         <Typography
//           variant="body1"
//           sx={{
//             mt: 2,
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             letterSpacing: 1,
//             lineHeight: "1.8rem",
//           }}
//         >
//           What sets our RMS program apart is the discipline-focused environment,
//           personalized attention, and consistent mentoring that nurture both
//           intellect and integrity. At Shree Mangalam School, we believe that
//           students with the right training and mindset can rise from any
//           background and earn their place among the best. Our Military School
//           program is a step toward that proud journey.
//         </Typography>

//         <Typography
//           variant="body1"
//           sx={{
//             mt: 2,
//             fontFamily: "Montserrat, sans-serif",
//             fontOpticalSizing: "auto",
//             fontStyle: "normal",
//             letterSpacing: 1,
//             lineHeight: "1.8rem",
//           }}
//         >
//           Give your child the edge they deserve. Enroll in our Rashtriya
//           Military School (RMS) and become part of a growing success story at
//           Shree Mangalam School.
//         </Typography>
//       </Container>
//       <CallToEnroll />
//       <Footer />
//     </>
//   );
// };

// export default Military;

import React from "react";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import { 
  Container, 
  Typography, 
  Box, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper 
} from "@mui/material";
import Footer from "../../Components/Footer";
import CallToEnroll from "../../Components/CallToEnroll";
import PageTitle from "../../Components/PageTitle";
import MilitaryBanner from "../../assets/Military.png";

const Military = () => {
  const eligibilityCriteria = [
//     {
//   parameter: "Age Limit (Class 9)",
//   criteria: "13–15 years as on 1st July of admission year",
//   class: "Class 9"
// },
    { 
      parameter: "Age Limit", 
      criteria: "10 to 12 years as of 1st July of admission year",
      class: "Class 6 (For most RMS)"
    },
    { 
      parameter: "Educational Qualification", 
      criteria: "Passed Class 5th from a recognized school",
      class: "Class 5"
    },
    { 
      parameter: "Nationality", 
      criteria: "Must be an Indian citizen",
      class: "All Classes"
    },
    { 
      parameter: "Medical Fitness", 
      criteria: "Must meet prescribed medical standards (height, weight, eyesight)",
      class: "All Classes"
    },
    { 
      parameter: "Date of Birth Proof", 
      criteria: "Birth certificate or school records required",
      class: "All Classes"
    },
    { 
      parameter: "Reservation Categories", 
      criteria: "SC/ST/OBC/EWS as per government norms",
      class: "All Classes"
    },
  ];

  return (
    <>
      <Navbar />
      <PageTitle
        title="Military School Coaching - Shree Mangalam School"
        description="Get the best coaching for Military School entrance exams at Shree Mangalam School. Expert guidance, mock tests, and a disciplined learning environment."
        url="/military"
        keywords="military school coaching, RMS coaching, military entrance exam preparation, Rashtriya Military School classes, Shree Manglam military coaching"
      />

      <Header image={MilitaryBanner} alt={"Military School Coaching Banner"} />

      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Rashtriya Military School (RMS)
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, we proudly offer expert
          coaching for the Rashtriya Military School (RMS) Entrance Examination,
          preparing students for a life of discipline, leadership, and national
          pride. Our program is tailored to help students from jaipur-gudha state highway (Just on by pass) gudha gorji,
          and neighboring towns secure admission into India's
          premier military schools — institutions that shape the future leaders
          of our armed forces.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          The Military School entrance coaching covers all key subjects:
          Mathematics, English, General Knowledge, and Intelligence Reasoning,
          aligned with the latest exam pattern. We ensure thorough practice
          through mock exams, doubt-solving sessions, and interview preparation.
          Special attention is given to character building, time management, and
          physical fitness tips, so students are ready for every stage of the
          selection process.
        </Typography>

        {/* Eligibility Criteria Table Section */}
        <Box sx={{ mt: 6, mb: 4 }}>
          <Typography
            variant="h5"
            sx={{
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              fontSize: "26px",
              letterSpacing: 1,
              color: "#AD1C86",
              fontWeight: "bold",
              mb: 3,
            }}
          >
            Eligibility Criteria for RMS Admission
          </Typography>
          
          <TableContainer 
            component={Paper} 
            sx={{ 
              borderRadius: 2, 
              overflow: 'hidden',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
              mb: 3,
              overflowX: "auto",
            }}
          >
            <Table sx={{ minWidth: 650 }}>
              <TableHead>
                <TableRow sx={{ bgcolor: '#065A79' }}>
                  <TableCell 
                    sx={{ 
                      color: 'white', 
                      fontWeight: 'bold',
                      fontSize: '16px',
                      fontFamily: 'Montserrat, sans-serif'
                    }}
                  >
                    Parameter
                  </TableCell>
                  <TableCell 
                    sx={{ 
                      color: 'white', 
                      fontWeight: 'bold',
                      fontSize: '16px',
                      fontFamily: 'Montserrat, sans-serif'
                    }}
                  >
                    Eligibility Criteria
                  </TableCell>
                  <TableCell 
                    sx={{ 
                      color: 'white', 
                      fontWeight: 'bold',
                      fontSize: '16px',
                      fontFamily: 'Montserrat, sans-serif'
                    }}
                  >
                    Class
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {eligibilityCriteria.map((row, index) => (
                  <TableRow 
                    key={index}
                    sx={{ 
                      '&:nth-of-type(odd)': { bgcolor: '#F8F9FA' },
                      '&:hover': { bgcolor: '#F0F7FF' }
                    }}
                  >
                    <TableCell 
                      component="th" 
                      scope="row"
                      sx={{ 
                        fontWeight: 'bold',
                        fontFamily: 'Montserrat, sans-serif',
                        color: '#065A79'
                      }}
                    >
                      {row.parameter}
                    </TableCell>
                    <TableCell 
                      sx={{ 
                        fontFamily: 'Montserrat, sans-serif',
                        lineHeight: '1.6'
                      }}
                    >
                      {row.criteria}
                    </TableCell>
                    <TableCell 
                      sx={{ 
                        fontFamily: 'Montserrat, sans-serif',
                        fontWeight: 'medium'
                      }}
                    >
                      {row.class}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Typography
            variant="body2"
            sx={{
              fontFamily: "Montserrat, sans-serif",
              fontOpticalSizing: "auto",
              fontStyle: "normal",
              letterSpacing: 0.5,
              lineHeight: "1.6rem",
              color: "#555",
              fontStyle: 'italic',
              p: 2,
              bgcolor: '#F8F9FA',
              borderRadius: 1
            }}
          >
            <strong>Note:</strong> Age relaxation is applicable for reserved categories (SC/ST/OBC) 
            as per government norms. Exact age criteria may vary between different Rashtriya Military Schools. 
            Please check the specific school's official notification for precise details.
          </Typography>
        </Box>

        <Typography
          variant="body1"
          sx={{
            mt: 4,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          What sets our RMS program apart is the discipline-focused environment,
          personalized attention, and consistent mentoring that nurture both
          intellect and integrity. At Shree Mangalam School, we believe that
          students with the right training and mindset can rise from any
          background and earn their place among the best. Our Military School
          program is a step toward that proud journey.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Give your child the edge they deserve. Enroll in our Rashtriya
          Military School (RMS) and become part of a growing success story at
          Shree Mangalam School.
        </Typography>
      </Container>
      <CallToEnroll />
      <Footer />
    </>
  );
};

export default Military;